import { useTranslation } from 'react-i18next'
import poster from '../assets/images/aboutPoster.avif'
import video from '../assets/videos/About.mp4'

export default function AboutBanner({ id }) {
  const { t } = useTranslation()
  return (
    <article
      id={id}
      className='flex justify-center py-16 sm:py-24'
    >
      <section className='w-[92%] lg:w-5/6 flex flex-col md:flex-row items-center gap-8 2xl:gap-16'>
        <div className='w-full xl:w-3/5 2xl:w-2/3'>
          <div className='w-full lg:mb-0'>
            <h2 className='sm:text-3xl text-xl uppercase font-[900] sm:mb-2'>
              {t('aboutSection.aboutTitle')}
            </h2>
            <div className='h-1 w-20 bg-gradient-to-r from-purple-500 to-blue-500 rounded-full'></div>
          </div>
          <h3 className='mt-2 sm:mt-4 sm:text-xl text-lg font-normal text-gray-600'>
            {t('aboutSection.aboutContent')}
          </h3>
        </div>
        <div className='hidden xl:block w-2/5 2xl:w-1/3'>
          <video
            className='h-full lg:h-[600px] bg-black pointer-events-none select-none brightness-125 object-cover'
            loop
            autoPlay
            muted
            playsInline
            controls={false}
            preload='auto'
            width='100%'
            height='100%'
            poster={poster}
          >
            <source
              src={video}
              type='video/mp4'
            ></source>
          </video>
        </div>
      </section>
    </article>
  )
}
